export const processData = {
  badge: "OUR PROCESS",
  headline: "Proven Marketing Systems That Drive Revenue",
  description:
    "Your potential patients are searching — not browsing. We run targeted campaigns that put your clinic in front of people ready to book now. Every strategy includes full CRM integration, call tracking, and automated follow-up to help you turn leads into loyal patients.",
  features: [
    {
      iconName: "Target",
      title: "High-Impact Campaign Strategies",
      description:
        "Dominate search, social, and local visibility with campaigns designed to reach your ideal patients at the exact moment they're ready to act.",
    },
    {
      iconName: "MessageSquare",
      title: "Follow-Ups & Lead Nurturing",
      description:
        "Stop losing opportunities to missed calls or slow replies. Our dedicated team texts, emails, and follows up with every lead — so your calendar stays full without extra work from your team.",
    },
  ],
  image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&q=80",
};
